import poptoken_builder from "./poptoken-builder-node";

export const createPopToken = (method, url, authorization, body, privateKey) => {
    const ehtsKeyValueMap = new Map();
    const pathname = new URL(url).pathname;
    ehtsKeyValueMap.set('uri', pathname);
    ehtsKeyValueMap.set('http-method', method.toUpperCase());
  
    const privateKeyPemStr = '' + privateKey;
    try {
      const popToken = poptoken_builder.buildPopToken(
        ehtsKeyValueMap,
        privateKeyPemStr
      );
      return popToken;
    } catch (error) {
      console.log('Error:', error);
    }
  };